// extracted by mini-css-extract-plugin
export default {"issueCalendar":"Main_issueCalendar__d3jXG","vehicleAssignment":"Main_vehicleAssignment__9gc2S","workOrderDashboard":"Main_workOrderDashboard__DQQ3T"};